import {useContext, useEffect} from 'react';
import { Box } from '@mui/material';
import { TextInput } from '../../components/inputs';
import {DefinitionsContext} from "../../context/DefinitionsContext";


function IncidentReport({report , setReport, onValidChange, disabled=false}) {
    const { translationList } = useContext(DefinitionsContext);
  return (
    <Box>
      <TextInput
        disabled={disabled}
        label={translationList.incidentReport}
        value={report}
        onChange={(e) => setReport(e.target.value)}
        onValidChange={onValidChange}
        isRequired
        multiline
        max={3000}
        rows={4}
      />
    </Box>
  )
}

export default IncidentReport;
export { IncidentReport };